<template>
<div class="pa-3 full-width">
    <div class="chart-heading mb-2 ml-1">Submissions</div>

    <div class="elevation-1 white pa-3 mb-4 rounded">

        This month {{formatMillions(amountSubmittedThis)}}
        <v-progress-linear class="mb-4" height="8" rounded :value="amountSubmittedThis / targetSubmissions * 100" />
        <div class="light-text">Target {{targetSubmissionsMillions}} with {{daysThisMonth - dayOfMonth}} days remaining</div>
        <v-progress-linear color="grey" class="mb-4" height="8" rounded :value="dayOfMonth / daysThisMonth * 100" />
    </div>
    <div class="elevation-1 white pa-3 mb-4 rounded " >
        Last month {{formatMillions(amountSubmittedLast)}}
        <v-progress-linear height="8" color="purple" rounded :value="amountSubmittedLast / targetSubmissions * 100" />
    </div>

    <div class="chart-heading mb-2 ml-1">Settlements</div>

    <div class="elevation-1 white pa-3 mb-4 rounded" >
        This month {{formatMillions(amountSettledThis)}}
        <v-progress-linear class="mb-4" height="8" rounded :value="amountSettledThis / targetSubmissions * 100" />
        <div class="light-text">Target {{targetSettlementsMillions}} with {{daysThisMonth - dayOfMonth}} days remaining</div>
        <v-progress-linear color="grey" class="mb-4" height="8" rounded :value="dayOfMonth / daysThisMonth * 100" />
    </div>
    <div class="elevation-1 white pa-3 rounded mb-10" >
        Last month {{formatMillions(amountSettledLast)}}
        <v-progress-linear height="8" color="purple" rounded :value="amountSettledLast / targetSubmissions * 100" />
    </div>

    <v-btn depressed rounded @click="dialog.settings.visible = true">Set Targets</v-btn>

    <NoRecordsPlaceholder v-if="false">
        Nothing tomorrow!
    </NoRecordsPlaceholder>

    <DialogBox title="Settings" :settings="dialog.settings" @close="saveSettings()">
        <div class="pa-3">
        <div>Target Submissions {{targetSubmissionsMillions}}</div>
        <v-slider v-model="targetSubmissions" min="0" max="30000000" step="100000" ></v-slider>
        <div>Target Settlements {{targetSettlementsMillions}}</div>
        <v-slider v-model="targetSettlements" min="0" max="30000000" step="100000" ></v-slider>
        </div>
    </DialogBox>


</div>
</template>

<script>
import Utilities from '../../helpers/Utilities'
import DataHelpers from '../../helpers/DataHelpers'
import ContactHelpers from '../../helpers/ContactHelpers'
import TeamHelpers from '../../helpers/TeamHelpers'
import NiceData from '../../data/NiceData'
import ChartControl from './ChartControl'
import DateHelpers from '../../helpers/DateHelpers'
import ImageGroup from '../../ui-elements/ImageGroup'
import NoRecordsPlaceholder from '../../ui-elements/NoRecordsPlaceholder'
import DialogBox from '../../ui-elements/DialogBox'

import {subMonths, startOfMonth, endOfMonth, getDaysInMonth, getDate} from 'date-fns'

// import { format } from 'date-fns'
export default {
name: 'VolumeChart',
props: {
    tenantKey: String,
    chart: Object
},
components: {
    ImageGroup, NoRecordsPlaceholder, DialogBox
},

data() {
return {
    transactions: {},
    submittedThisMonth: [],
    settledThisMonth: [],
    submittedLastMonth: [],
    settledLastMonth: [],
    targetSubmissions: 5000000,
    targetSettlements: 4000000,
    daysThisMonth: 30,
    dayOfMonth: 1,
    dialog: {
        settings: {
            visible: false,
            closeOnly: true,
        }
    }
}
},

asyncComputed: {
    officeName: {
      async get () {
        return TeamHelpers.officeNumberToName(this.tenantKey)
      },
      default: ''
    }
},


computed:{
    targetSubmissionsMillions() {
        return '$' + Math.round(this.targetSubmissions / 100000) / 10 + 'm'
    },

    targetSettlementsMillions() {
        return '$' + Math.round(this.targetSettlements / 100000) / 10 + 'm'
    },

    amountSubmittedThis() {
        return this.totalNewMoney(this.submittedThisMonth)
    },
    amountSubmittedLast() {
        return this.totalNewMoney(this.submittedLastMonth)
    },
    amountSettledThis() {
        return this.totalNewMoney(this.settledThisMonth)
    },
    amountSettledLast() {
        return this.totalNewMoney(this.settledLastMonth)
    },
},
methods: {

    formatMillions(amt) {
        return '$' + Math.round(amt / 10000) / 100 + 'm'
    },

    saveSettings() {
        TeamHelpers.saveTeamSettings({
            targetSubmissions: this.targetSubmissions,
            targetSettlements: this.targetSettlements
        })
    },

    transactionLink(transactionKey) {
        return '/' + this.tenantKey + '/transaction/' + transactionKey
    },

    clientImages(clientsObj) {
        const clients = Utilities.objectToObjectArray(clientsObj)
        const images = clients.map(o => o.image)
        return images
    },
    clientNames(clientsObj) {
        const clients = Utilities.objectToObjectArray(clientsObj)
        const names = ContactHelpers.combineClientsNames(clients)
        return names
    },

    totalNewMoney(arr) {
        if(!arr || arr.length == 0)
            return 0
        return arr.reduce(function(a, b) {
            return a + (b.total_new_money || 0)
        }, 0)
    },

    async loadSettings() {
        const settings = await(TeamHelpers.fetchTeamSettings())
        this.targetSubmissions = settings.targetSubmissions || this.targetSubmissions
        this.targetSettlements = settings.targetSettlements || this.targetSettlements
    }

},
created() {
    const today = new Date()
    const oneMonthAgo = subMonths(today, 1)
    const startOfThisMonth = DateHelpers.dateToBackwards(startOfMonth(today) )
    const endOfThisMonth = DateHelpers.dateToBackwards(endOfMonth(today) )
    const startOfLastMonth = DateHelpers.dateToBackwards(startOfMonth(oneMonthAgo) )
    const endOfLastMonth = DateHelpers.dateToBackwards(endOfMonth(oneMonthAgo) )

    this.daysThisMonth = getDaysInMonth(today)
    this.dayOfMonth = getDate(new Date())

    const milestoneRef = DataHelpers.getTenantRef(this.tenantKey).child('milestones')
    //const ref = milestoneRef.limitToLast(200)
    //const milestones = await NiceData.fetchItemsFromFirebase(ref)

    const submittedThisRef = milestoneRef.orderByChild('submitted_date').startAt(startOfThisMonth).endAt(endOfThisMonth)
    const settledThisRef = milestoneRef.orderByChild('settlement_confirmed_date').startAt(startOfThisMonth).endAt(endOfThisMonth)
    const submittedLastRef = milestoneRef.orderByChild('submitted_date').startAt(startOfLastMonth).endAt(endOfLastMonth)
    const settledLastRef = milestoneRef.orderByChild('settlement_confirmed_date').startAt(startOfThisMonth).endAt(endOfLastMonth)


    NiceData.fetchItemsFromFirebase(submittedThisRef).then(items => {
        this.submittedThisMonth = items
    })
    NiceData.fetchItemsFromFirebase(submittedLastRef).then(items => {
        this.submittedLastMonth = items
    })
    NiceData.fetchItemsFromFirebase(settledThisRef).then(items => {
        this.settledThisMonth = items
    })
    NiceData.fetchItemsFromFirebase(settledLastRef).then(items => {
        this.settledLastMonth = items
    })

    this.loadSettings()


}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .date-section {
        display:flex;flex-wrap:wrap;background-color:#f0f0f0;padding:15px;border-radius:7px
    }
    .date-card {
        border-radius:7px;width:350px; height:150px;margin:8px;margin-top:22px;text-align:center;background-color:white;
    }
    .date-bar {
        height:4px;width:300px;margin:10px auto;border-radius:3px;
    }
    .chart-outline {
        min-width:100%;
        margin-top:-35px;
    }
    .chart-header {
        width:100%;font-weight: bold; padding:10px;
        color:#888; height:35px;
    }
    .chart-row {
        width:100%;
    }
    .chart-column {
        padding:1px; flex-grow: 1;
    }
    .chart-cell {
        /* background-color: #eee; */
        height:60px;
    }
    .chart-heading {
        font-size:28px;
        color:rgb(5, 116, 150);
    }

</style>


// WEBPACK FOOTER //
// VolumeChart.vue?79bfa02d